import React, { useEffect, useState } from 'react';
import { Input, Select } from 'enspire-manager-framework';
import { numPanels } from 'components/common/toolbox';
import { useParams } from 'react-router-dom';

var _ = require('lodash');
var moment = require('moment');

export default function DateRange(props) {

    const params = useParams();

    const [state, setState] = useState({
        showOverlay: false,
        startdate: null,
        enddate: null,
        rangeName: null,
    });

    // Set initial state from localStorage or props
    useEffect(() => {
        let dateStorage = localStorage.getItem(`${params.handle}-DateRange`);
        let dateRange = (dateStorage) ? JSON.parse(dateStorage) : null;
        if (dateRange) {
            handlePreset(null, dateRange.rangeName);
        } else { 
            handlePreset(null, (props.range) ? props.range : 'last30');
        }
        if (props.onChange) props.onChange({ startdate: state.startdate, enddate: state.enddate });
    }, []);

    // Update localStorage and call onChange when state changes
    useEffect(() => {
        localStorage.setItem(`${params.handle}-DateRange`, JSON.stringify({ rangeName: state.rangeName, startdate: state.startdate, enddate: state.enddate }));
        if (props.onChange) props.onChange({ startdate: state.startdate, enddate: state.enddate });
    }, [state]);

    const handleDate = (name, date, context) => {
        setState(prev => ({ ...prev, [name]: date, fetched: false, rangeName: props.buttonTitle }));
        setState(prev => ({ ...prev, rangeName: 'Custom' }));
        if (props.onChange) props.onChange({ startdate: state.startdate, enddate: state.enddate, ...{ [name]: date }});
    }
    const handleSubmit = () => {
        if (props.callback) props.callback(state.startdate, state.enddate);
        setState(prev => ({ ...prev, showOverlay: false }));
    }
    const handlePreset = (e, value) => {
        var value = (value) ? value : e.target?.value;

        if (value) {
            var startdate;
            var enddate;
    
            switch (value) {
                case 'thisWeek':
                    startdate = moment().startOf('week').toDate();
                    enddate = moment().endOf('week').toDate();
                    break;
                case 'lastWeek':
                    startdate = moment().subtract(1, 'week').startOf('week').toDate();
                    enddate = moment().subtract(1, 'week').endOf('week').toDate();
                    break;
                case 'thisMonth':
                    startdate = moment().startOf('month').toDate();
                    enddate = moment().endOf('month').toDate();
                    break;
                case 'lastMonth':
                    startdate = moment().subtract(1, 'month').startOf('month').toDate();
                    enddate = moment().subtract(1, 'month').endOf('month').toDate();
                    break;
                case 'last30':
                    startdate = moment().subtract(30, 'days').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'last60':
                    startdate = moment().subtract(60, 'days').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'last90':
                    startdate = moment().subtract(90, 'days').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'last120':
                    startdate = moment().subtract(120, 'days').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'last6Months':
                    startdate = moment().subtract(6, 'months').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'last12Months':
                    startdate = moment().subtract(12, 'months').startOf('day').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
                case 'thisYear':
                    startdate = moment().startOf('year').toDate();
                    enddate = moment().endOf('year').toDate();
                    break;
                case 'yeartodate':
                    startdate = moment().startOf('year').toDate();
                    enddate = moment().endOf('day').toDate();
                    break;
            }
            setState(prev => ({ ...prev, startdate, enddate, rangeName: value, showOverlay: false }));
            if (props.onChange) props.onChange({ startdate, enddate });
        }
    }

    return (

        <div className="mt-n3">
            <div className={'row animated fadeInRight animation-delay-4' + props.className}>
                <div className="col-12"><p className="mb-1">Date Range</p></div>
                <div className={'col-md-8 input-group input-group-sm date'}>
                    <Input
                        className={`pr-0 ${numPanels(1)?'col-6 px-0':''}`}
                        dateFormat="MM-DD-YYYY"
                        minDate={moment('2000-01-01').toDate()}
                        maxDate={state.enddate}
                        name={'startdate'}
                        noLabel={true}
                        onChange={handleDate}
                        prepend={ <i className="fa-regular fa-calendar-day"></i> }
                        type="date"
                        value={state.startdate}
                    />
                    <Input
                        className={`pr-0 ${numPanels(1)?'col-6 px-0':''}`}
                        dateFormat="MM-DD-YYYY"
                        minDate={state.startdate}
                        maxDate={moment('2100-01-01').toDate()}
                        name={'enddate'}
                        noLabel={true}
                        onChange={handleDate}
                        type="date"
                        value={state.enddate}
                    />
                </div>

                {props.showPresets

                    ?   <div className={'col-sm-4'}>
                            <Select noLabel onChange={handlePreset} value={ state.rangeName }>
                                <option value={ 'thisWeek' }>This Week</option>
                                <option value={ 'lastWeek' }>Last Week</option>
                                <option value={ 'thisMonth' }>This Month</option>
                                <option value={ 'lastMonth' }>Last Month</option>
                                <option value={ 'last30' }>Last 30 Days</option>
                                <option value={ 'last60' }>Last 60 Days</option>
                                <option value={ 'last90' }>Last 90 Days</option>
                                <option value={ 'last120' }>Last 120 Days</option>
                                <option value={ 'last6Months' }>Last 6 Months</option>
                                <option value={ 'last12Months' }>Last 12 Months</option>
                                <option value={ 'thisYear' }>This Year</option>
                                <option value={ 'yeartodate' }>Year to Date</option>
                            </Select>

                            {/* <DropdownButton 
                                title=<span>
                                    {state.rangeName}
                                    {props.rendering &&
                                        <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                    }
                                </span> 
                                variant="primary" size="sm" className="d-inline ml-2 mb-2"
                                onClick={(event) => { if (event?.stopPropagation) event?.stopPropagation(); }}
                            >
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'thisWeek', 'This Week')}>This Week</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'lastWeek', 'Last Week')}>Last Week</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'thisMonth', 'This Month')}>This Month</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'lastMonth', 'Last Month')}>Last Month</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'last60', 'Last 60 Days')}>Last 60 Days</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'last90', 'Last 90 Days')}>Last 90 Days</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'last120', 'Last 120 Days')}>Last 120 Days</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'last6Months', 'Last 6 Months')}>Last 6 Months</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'last12Months', 'Last 12 Months')}>Last 12 Months</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'thisYear', 'This Year')}>This Year</Dropdown.Item>
                                <Dropdown.Item eventKey="1" onClick={handlePreset.bind(this, 'yeartodate', 'Year to Date')}>Year to Date</Dropdown.Item>
                            </DropdownButton> */}
                        </div>
                    :   <div className="col-lg-4 pt-1">
                            <button className={'btn btn-primary btn-xs'} onClick={handleSubmit}>
                                {props.buttonTitle}
                                {props.rendering &&
                                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                }
                            </button>
                        </div>
                }
                {/* </div> */}
            </div>

            {props.children &&
                <div>
                    {(!Array.isArray(props.children)) ? React.cloneElement(props.children, { startdate: state.startdate, enddate: state.enddate }) : <></>}
                    {(props.children?.[0]) ? React.cloneElement(props.children?.[0], { startdate: state.startdate, enddate: state.enddate }) : <></>}
                    {(props.children?.[1]) ? React.cloneElement(props.children?.[1], { startdate: state.startdate, enddate: state.enddate }) : <></>}
                    {(props.children?.[2]) ? React.cloneElement(props.children?.[2], { startdate: state.startdate, enddate: state.enddate }) : <></>}
                    {(props.children?.[3]) ? React.cloneElement(props.children?.[3], { startdate: state.startdate, enddate: state.enddate }) : <></>}
                </div>
            }
        </div>
    );
};